import React from 'react'
import { useDispatch } from 'react-redux'
import { updateSearchAction } from 'src/effects/Search/actions'
import { formatISO } from 'lib/dates'
import DatePicker from 'src/comps/Molecules/DatePicker'
import { SearchMode } from 'src/types/search'
import noop from 'lodash/noop'
import { getMinBookingDate } from 'src/context/search/utils'

interface IDateSelectorProps {
  readonly checkIn: Date
  readonly checkOut: Date
  readonly mode: SearchMode
  readonly handleUpdate?: () => void
}

export function DateSelectorConnected(props: IDateSelectorProps) {
  const { checkIn, checkOut, mode, handleUpdate = noop } = props

  const today = new Date()
  const minBookingDateObject = getMinBookingDate(
    {
      year: today.getFullYear(),
      month: today.getMonth(),
      date: today.getDate(),
      hours: today.getHours(),
      minutes: today.getMinutes(),
    },
    {
      year: today.getUTCFullYear(),
      month: today.getUTCMonth(),
      date: today.getUTCDate(),
      hours: today.getUTCHours(),
      minutes: today.getUTCMinutes(),
    }
  )
  const { year, month, date, hours, minutes } = minBookingDateObject
  const minDate = new Date(year, month, date, hours, minutes)

  const dispatch = useDispatch()

  function updateSearch(payload: { checkIn: Date; checkOut: Date }) {
    if (payload.checkIn && payload.checkOut) {
      dispatch(
        updateSearchAction({
          ...payload,
          checkIn: formatISO(payload.checkIn),
          checkOut: formatISO(payload.checkOut),
        })
      )

      if (handleUpdate) {
        handleUpdate()
      }
    }
  }

  return (
    <DatePicker
      mode={mode}
      initialValue={{ checkIn, checkOut }}
      onChange={updateSearch}
      firstAvailableDate={minDate}
    />
  )
}
